export default {
  appointmentCountTableRowsPerPage: 20,
  bookingRequestCountTableRowsPerPage: 10,
  countTableRowsPerPage: 10,
  emailMessageCountTableRowsPerPage: 10,
  emailTemplateCountTableRowsPerPage: 12,
  emailTemplateSelectLimit: 100,
};
